import React from "react";
import { Typography, Box, Grid, Stack, Button } from "@mui/material";
import { ReactComponent as ArrowrightIcon } from "../../../../vendor/_new/icon/sites/arrow_right.svg";
import { ReactComponent as ArrowleftIcon } from "../../../../vendor/_new/icon/sites/arrow_left.svg";
import { ReactComponent as WebIcon } from "../../../../vendor/_new/icon/sites/www.svg";
import { ReactComponent as ServerIcon } from "../../../../vendor/_new/icon/sites/origin.svg";
import { ReactComponent as CertIcon } from "../../../../vendor/_new/icon/sites/check_rounded.svg";
import { ReactComponent as RedirectIcon } from "../../../../vendor/_new/icon/sites/next_line.svg";
import { ReactComponent as SignaturewafIcon } from "../../../../vendor/_new/icon/sites/signature_waf.svg";
import { ReactComponent as GlobalIcon } from "../../../../vendor/_new/icon/services/global.svg";
import { ReactComponent as EnabledIcon } from "../../../../vendor/_new/icon/sites/enabled.svg";
import { ReactComponent as DisabledIcon } from "../../../../vendor/_new/icon/sites/disabled.svg";
import colors from "../../../../utils/colors";
import useSite from "../../../../hooks/user/useSite";
import useSSLConfig from "../../../../hooks/user/useSSLConfig";
import { CertificateType, SslType } from "../../../../utils/constants";
import useWAFConfig from "../../../../hooks/user/useWAFConfig";
import { containedButtonSx, outlinedButtonSx } from "../../../common/Button";

const ReviewCard = ({ icon: Icon, label, value, isEnabled = null }) => {
  let valueColor = colors.primary[300];
  if (isEnabled === true) {
    valueColor = colors.green[300];
  } else if (isEnabled === false) {
    valueColor = colors.neutral[500];
  }

  const isStatusCard = isEnabled !== null;

  return (
    <Box
      sx={{
        borderRadius: "8px",
        border: `1px solid ${colors.neutral[200]}`,
        backgroundColor: "#fff",
        p: 2,
        height: "100%",
        minHeight: 80,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <Icon style={{ width: 24, height: 24, color: colors.primary[300] }} />
        <Typography
          sx={{
            fontSize: 14,
            lineHeight: "21px",
            fontWeight: "medium",
            color: colors.neutral[1000],
          }}
        >
          {label}
        </Typography>
      </Stack>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        {isStatusCard ? (
          <Stack direction="row" alignItems="center" spacing={1}>
            {isEnabled ? (
              <EnabledIcon style={{ width: 24, height: 24, color: colors.green[300] }} />
            ) : (
              <DisabledIcon style={{ width: 24, height: 24, color: colors.neutral[500] }} />
            )}
            <Typography
              sx={{
                fontSize: 18,
                lineHeight: "27px",
                fontWeight: "medium",
                color: valueColor,
              }}
            >
              {value}
            </Typography>
          </Stack>
        ) : (
          <Typography
            sx={{
              fontSize: 18,
              lineHeight: "27px",
              fontWeight: "medium",
              color: valueColor,
            }}
          >
            {value}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

const ReviewConfiguration = ({ handleNext, handlePrev }) => {
  const { cursite } = useSite();
  const { sslConfig } = useSSLConfig();
  const { wafConfig } = useWAFConfig();

  const sslEnabled = sslConfig?.ssl_type !== SslType.OFF;
  const httpsRedirectEnabled = sslConfig?.https_redirect_enabled === true;
  const signatureWafEnabled = wafConfig?.sd_sig_module_active === true;
  const smartParseWafEnabled = wafConfig?.smart_parse_module_active === true;
  const certificateTypeLabel =
    sslConfig?.certs?.type === CertificateType.SENSE_GUARD
      ? "Layerd AI managed"
      : sslConfig?.certs?.type === CertificateType.CUSTOM
      ? "User managed"
      : "—";

  return (
    <Box sx={{ width: "100%" }}>
      <Typography sx={ { fontSize: 14, lineHeight: "21px", color: colors.neutral[800], pb: 3 }}>
        Review configuration for your application
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <ReviewCard icon={WebIcon} label="Domain name" value={cursite?.site_id || "—"} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ReviewCard icon={ServerIcon} label="Origin name/IP" value={cursite?.addr || "—"} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ReviewCard icon={CertIcon} label="SSL Status" value={sslEnabled ? "Enabled" : "Disabled"} isEnabled={sslEnabled} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ReviewCard icon={RedirectIcon} label="HTTPS Redirection" value={httpsRedirectEnabled ? "Enabled" : "Disabled"} isEnabled={httpsRedirectEnabled} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ReviewCard icon={CertIcon} label="Certificate Type" value={certificateTypeLabel} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ReviewCard
            icon={SignaturewafIcon}
            label="Signature WAF"
            value={signatureWafEnabled ? "Enabled" : "Disabled"}
            isEnabled={signatureWafEnabled}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ReviewCard
            icon={GlobalIcon}
            label="Layerd AI Smart Parse"
            value={smartParseWafEnabled ? "Enabled" : "Disabled"}
            isEnabled={smartParseWafEnabled}
          />
        </Grid>
      </Grid>
      <Stack direction={"row"} alignItems={"center"} spacing={4} sx={{ pt: 4 }}>
        <Button
          startIcon={<ArrowleftIcon style={{ color: "#6371F7" }} />}
          onClick={handlePrev}
          sx={{ height: 36, ...outlinedButtonSx }}
        >
          Back
        </Button>
        <Button
          endIcon={<ArrowrightIcon style={{ color: "#fff" }} />}
          onClick={handleNext}
          sx={{ height: 36, ...containedButtonSx }}
        >
          Continue
        </Button>
      </Stack>
    </Box>
  );
};
export default ReviewConfiguration;
